import { render, staticRenderFns } from "./AboutModal.yaml?vue&type=template&id=290cbf12&component"
import script from "./AboutModal.yaml?vue&type=script&lang=ts&component"
export * from "./AboutModal.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports